import { useMemo } from 'react';
import { useStationeryCurrencies } from '@shared/utils/currency/useStationeryCurrencies';
import { COUNTRY_LIST } from './constants';

const US_ONLY: ReadonlyArray<string> = ['US'];

/**
 * Returns the countries Joy sells stationery and photo products to, as `COUNTRY_LIST` dropdown entries.
 *
 * The list is the union of `countryCodes` across card_service's currencies (see
 * {@link useStationeryCurrencies}). It is US-only until that query resolves, so no address dropdown flashes
 * empty or briefly offers every country.
 *
 * All stationery / photo address flows should use this hook so the derivation stays in one place. Lives in
 * `@shared` rather than `@apps/card` because both card and admin flows consume it.
 */
export const useStationeryCountryList = () => {
  const currencies = useStationeryCurrencies();

  return useMemo(() => {
    const allowedCodes = new Set(currencies?.flatMap(currency => currency.countryCodes) ?? US_ONLY);
    return COUNTRY_LIST.filter(({ value }) => allowedCodes.has(value));
  }, [currencies]);
};
